<script>
    import { t } from "$utils/lang.js";

    let {
        open = $bindable(false),
        title = '',
        message = '',
        confirmLabel = t('Bestätigen'),
        cancelLabel = t('Abbrechen'),
        confirmVariant = 'danger', // 'danger' | 'primary'
        onConfirm = () => {},
        onCancel = () => {},
    } = $props();

    let dialog;

    // Sync `open` ↔ <dialog> via showModal()/close().
    $effect(() => {
        if (!dialog) return;
        if (open && !dialog.open) {
            dialog.showModal();
        } else if (!open && dialog.open) {
            dialog.close();
        }
    });

    // ESC, backdrop dismiss, or close-via-form fire native 'close'
    function handleClose() {
        if (open) {
            open = false;
            onCancel();
        }
    }

    // Click outside the inner panel = cancel
    function handleBackdropClick(e) {
        if (e.target === dialog) handleClose();
    }

    function confirm() {
        open = false;
        onConfirm();
    }

    const confirmCls = $derived(
        confirmVariant === 'danger'
            ? 'bg-scarlet hover:bg-[#c92121] text-white'
            : 'bg-cyprus hover:bg-[#003055] text-white'
    );
</script>

<dialog
    bind:this={dialog}
    onclose={handleClose}
    onclick={handleBackdropClick}
    class="m-auto rounded-lg p-0 shadow-2xl backdrop:bg-black/50 backdrop:backdrop-blur-sm w-[420px] max-w-[95vw]"
>
    <div class="bg-white p-5 flex flex-col gap-4">
        {#if title}
            <h3 class="text-base font-bold text-cyprus">{title}</h3>
        {/if}
        {#if message}
            <p class="text-sm text-gray-700">{message}</p>
        {/if}
        <div class="flex justify-end gap-3 pt-2">
            <button
                type="button"
                onclick={handleClose}
                class="px-4 py-2 rounded-md font-semibold text-sm border border-grey hover:bg-gray-50 transition-colors cursor-pointer"
            >
                {cancelLabel}
            </button>
            <button
                type="button"
                onclick={confirm}
                class="px-4 py-2 rounded-md font-semibold text-sm transition-colors cursor-pointer {confirmCls}"
            >
                {confirmLabel}
            </button>
        </div>
    </div>
</dialog>
